(function() {
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  vtex.define('shipping/script/models/Address',['shipping/script/module/alphanumponc'], function(alphanumponc) {
    var Address;
    return Address = (function() {
      var cleanStr;

      function Address(data) {
        var _ref, _ref1, _ref2;
        if (data == null) {
          data = {};
        }
        this.validate = __bind(this.validate, this);
        this.validateField = __bind(this.validateField, this);
        this.addressId = (_ref = data.addressId) != null ? _ref : (new Date().getTime() * -1).toString();
        this.addressType = (_ref1 = data.addressType) != null ? _ref1 : "residential";
        this.city = data.city;
        this.complement = data.complement;
        this.country = data.country;
        this.geoCoordinates = (_ref2 = data.geoCoordinates) != null ? _ref2 : [];
        this.neighborhood = data.neighborhood;
        this.number = data.number;
        this.postalCode = data.postalCode;
        this.receiverName = data.receiverName;
        this.reference = data.reference;
        this.state = data.state ? data.state.toUpperCase() : data.state;
        this.street = data.street;
      }

      Address.prototype.validateField = function(rules, name) {
        var isRequired, regexTest, rule, useGeoCoordinates, value;
        value = this[name];
        if (rules.regexes[name] != null) {
          regexTest = function(val) {
            return rules.regexes[name].test(val);
          };
        } else {
          regexTest = function(val) {
            return alphanumponc(val);
          };
        }
        useGeoCoordinates = this.geoCoordinates.length > 0;
        rule = _.find(rules.googleDataMap, function(r) {
          return r.value === name;
        });
        if (useGeoCoordinates && rule) {
          isRequired = rule.required === true;
        } else {
          isRequired = __indexOf.call(rules.requiredFields, name) >= 0;
        }
        if (isRequired && ((value == null) || value === "")) {
          return false;
        }
        if (!isRequired && !value) {
          return true;
        }
        return regexTest(value);
      };

      Address.prototype.validate = function(rules) {
        var cities, city, field, fieldsToValidate, state, _i, _j, _len, _len1, _ref, _ref1, _ref2,
          _this = this;
        if (this.addressType === "giftRegistry") {
          return true;
        }
        if (rules == null) {
          return "Country rules are required for validation";
        }
        if (rules.country === 'ARG' && ((_ref = this.state) === "Ciudad de Buenos Aires" || _ref === "Provincia de Buenos Aires")) {
          this.state = "Ciudad Autónoma de Buenos Aires";
          this.city = "Ciudad Autónoma Buenos Aires";
        }
        if (rules.country === 'PRY' && this.state === "Distrito Capital") {
          this.state = "Central";
        }
        if (rules.states) {
          this.state = (_ref1 = this.state) != null ? _ref1.toUpperCase() : void 0;
        }
        fieldsToValidate = ['postalCode', 'city', 'complement', 'neighborhood', 'number', 'receiverName', 'reference', 'street', 'state'];
        for (_i = 0, _len = fieldsToValidate.length; _i < _len; _i++) {
          field = fieldsToValidate[_i];
          if (!this.validateField(rules, field)) {
            return "" + field + " invalid (value: " + this[field] + ")";
          }
        }
        if (__indexOf.call(rules.requiredFields, 'geoCoordinates') >= 0 && this.geoCoordinates.length !== 2) {
          return 'geoCoordinates invalid';
        }
        if (rules.states && !_.find(rules.states, function(s) {
          return s.value === _this.state;
        })) {
          return 'state not in allowed states';
        }
        if (rules.cities) {
          _ref2 = rules.cities;
          for (state in _ref2) {
            cities = _ref2[state];
            for (_j = 0, _len1 = cities.length; _j < _len1; _j++) {
              city = cities[_j];
              if (rules.swapNeighborhoodWithCity && cleanStr(city) === cleanStr(this.neighborhood)) {
                return true;
              } else if (cleanStr(city) === cleanStr(this.city)) {
                return true;
              }
            }
          }
          return "City not in allowed cities list";
        }
        return true;
      };

      cleanStr = function(str) {
        if (str) {
          return _.plainChars(str.toLowerCase());
        } else {
          return '';
        }
      };

      return Address;

    })();
  });

}).call(this);

